module.exports = __webpack_public_path__ + "img/arrow-right-2.2a3902f5.svg";